module.exports = __webpack_public_path__ + "img/tarj1-1.d0d19ed7.png";